<template>
    <div
        ref="root"
        :class="$style.container"
    >
        <img
            :class="$style.icon"
            :src="Icon"
            alt="Save Icon"
        />
        <Typography
            size="m"
            type="label"
            :responsive="false"
            :class="$style.label"
        >
            {{ $tr('gameContainer.desktop_login_promo_label') }}
        </Typography>
        <div />
        <OutlineButton
            :class="$style.button_override"
            interfaceTarget="game-top-bar-ignore-button"
            size="s"
            :label="$tr('gameContainer.desktop_login_promo_ignore_button')"
            @click="emit('close')"
        />
        <Button
            color="lime"
            :class="$style.button_override"
            interfaceTarget="game-top-bar-login-button"
            size="s"
            :label="$tr('gameContainer.desktop_login_promo_login_button')"
            @click="emit('login')"
        />
    </div>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'
import { useTemplateRef } from 'vue'

import Button from '@/components/Buttons/Button.vue'
import OutlineButton from '@/components/Buttons/OutlineButton.vue'
import Typography from '@/components/Typography.vue'

import Icon from '../images/save.webp'

const emit = defineEmits<{
    shown: []
    close: []
    login: []
}>()

const root = useTemplateRef('root')
const { stop } = useIntersectionObserver(root, ([entry]) => {
    if (entry?.isIntersecting) {
        stop()
        emit('shown')
    }
})
</script>

<style module>
.container {
    display: none;
    align-items: center;
    grid-template-columns: auto auto 1fr auto auto;
    gap: 8px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    position: absolute;
    inset: 0;
    height: 32px;
    padding: 8px 16px;
    background: rgba(29, 28, 38, 0.56);
    backdrop-filter: blur(4px);
}

.icon {
    height: 32px;
    width: 32px;
}
.button_override {
    height: 32px;
}

.label {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (--desktop-small-plus) {
    .container {
        display: grid;
    }
}
</style>
